
export default function MissionSection() {
  const values = [
    {
      icon: 'ri-boxing-line',
      title: '企业使命',
      subtitle: 'MISSION',
      description: '凝聚环保理念，留住碧水蓝天，共创生态未来',
      bgColor: '#4677e0'
    },
    {
      icon: 'ri-hand-heart-line',
      title: '愿景',
      subtitle: 'VISION',
      description: '成为值得信赖的环境水务综合服务专家',
      bgColor: '#4677e0'
    },
    {
      icon: 'ri-shake-hands-line',
      title: '价值观',
      subtitle: 'VALUES',
      description: '专业、有价值、创新、可持续',
      bgColor: '#4677e0'
    }
  ];

  // const principles = [
  //   {
  //     title: '专业',
  //     description: '专业的技术团队，专业的服务标准，确保每个项目都达到最高水准',
  //     icon: 'ri-shield-check-line'
  //   },
  //   {
  //     title: '有价值',
  //     description: '为客户创造真正的价值，提供切实有效的环境治理解决方案',
  //     icon: 'ri-user-heart-line'
  //   },
  //   {
  //     title: '创新',
  //     description: '持续技术创新，运用最新科技成果解决水环境治理难题',
  //     icon: 'ri-lightbulb-line'
  //   },
  //   {
  //     title: '可持续',
  //     description: '追求经济效益与环境效益的完美平衡，实现可持续发展',
  //     icon: 'ri-leaf-line'
  //   }
  // ];

  return (
    <section className="py-8 md:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* 标题区：动态缩放，避免大屏过粗、小屏溢出 */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-[clamp(1.75rem,3.5vw,3rem)] font-bold text-gray-900 mb-6">
            企业理念
          </h2>
          {/* <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            凝聚环保理念，留住碧水蓝天，共创生态未来。万江环保科技始终坚持专业、有价值、创新、可持续的核心价值观
          </p> */}
        </div>

        {/* 理念卡片区：全元素响应式缩放，装饰图形同步适配 */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8 ">
          {values.map((value, index) => (
            <div
              key={index}
              className="relative bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl p-[clamp(1.5rem,3vw,2rem)] text-white overflow-hidden  transition-all duration-300 hover:-translate-y-2"
            >
              {/* 装饰圆形：用vw单位+最大限制，随屏幕同步缩放不偏移 */}
              <div className="absolute top-0 right-0 w-[15vw] h-[15vw] max-w-40 max-h-40 bg-white/10 rounded-full -translate-y-[6vw] translate-x-[6vw]"></div>
              <div className="absolute bottom-0 left-0 w-[12vw] h-[12vw] max-w-32 max-h-32 bg-white/10 rounded-full translate-y-[5vw] -translate-x-[5vw]"></div>

              {/* 内容层：图标、文字全用clamp()动态缩放 */}
              <div className="relative z-10">
                {/* 图标容器：宽高同步缩放，保持圆形比例 */}
                <div className="w-[clamp(3rem,6vw,4rem)] h-[clamp(3rem,6vw,4rem)] bg-white/20 rounded-2xl flex items-center justify-center mb-[clamp(1rem,2vw,1.5rem)]">
                  <i className={`${value.icon} text-white text-[clamp(1.25rem,2.5vw,1.5rem)]`}></i>
                </div>
                {/* 标题：动态字体，适配不同屏幕 */}
                <h3 className="text-[clamp(1.25rem,2.5vw,1.75rem)] font-bold mb-[clamp(0.5rem,1vw,0.75rem)]">
                  {value.title}
                </h3>
                {/* 副标题：轻量化缩放，与标题层级区分 */}
                <p className="text-blue-100 text-[clamp(0.8125rem,1.2vw,0.875rem)] font-medium mb-[clamp(0.75rem,1.5vw,1rem)]">
                  {value.subtitle}
                </p>
                {/* 描述文字：保持可读性，随屏幕微调 */}
                <p className="text-white/90 leading-relaxed text-[clamp(0.875rem,1.4vw,0.9375rem)]">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="bg-gray-50 rounded-3xl p-8 md:p-12">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              核心价值观
            </h3>
            <p className="text-xl text-gray-600">
              秉承专业、有价值、创新、可持续的核心价值观，为水环境保护事业不懈努力
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {principles.map((principle, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 text-center"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${principle.icon} text-[#4677e0] text-xl`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3">{principle.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed">{principle.description}</p>
              </div>
            ))}
          </div>
        </div> */}

        {/* <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-8 md:p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">
              携手共建美好水环境
            </h3>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              我们相信，通过专业的技术、创新的理念和负责任的态度，能够为中国的水环境保护事业作出更大贡献
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-[#4677e0] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解我们的服务
              </button>
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                联系我们
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}
